import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type AddImageResponse = {
  url: string;
  key: string;
  duration?: string;
} & ApiError;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AddImage = (
  formData: FormData,
  folderName: string,
  onUploadProgress: (progressEvent: any) => void,
  isVideo: boolean = false
): Promise<AddImageResponse> => {
  return axios
    .post(
      `/${isVideo ? "vdocipher" : "s3"}/upload${
        isVideo ? "" : `?folderName=${folderName}`
      }`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      }
    )
    .then((response) => response.data);
};
